export const iconFontAwesomeArrowsArrowDownZA = (
	<i className="fa-solid fa-arrow-down-z-a"></i>
);
